export default __webpack_public_path__ + "static/project-slide-2-4032-2268-8b5fb63ed7ca4120c811590a8f80dcf5.jpg";